import GenericEditForm from "../../../../components/GenericEditForm";

function EditActiveLocation() {
  return (
    <GenericEditForm
      title="Ubicación de Activo"
      endpoint="/active-locations"
      backTo="/actives/locations"
      fields={[
        {
          name: "name",
          label: "Nombre",
          type: "text",
          placeholder: "Nombre de la ubicación",
          required: true,
        },
        {
          name: "description",
          label: "Descripción",
          type: "textarea",
          placeholder: "Descripción de la ubicación",
          required: false,
        },
      ]}
    />
  );
}

export default EditActiveLocation;
